import { Outlet } from '@tanstack/react-router';
import { Header } from '@anytag/shared-molecules';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';

export const AddMarketplace = () => {
  useUpdateDocumentTitle({
    href: '/marketplace',
    alwaysBackToParent: true,
    title: 'documentTitle.AddMarketplace',
    appHeader: 'appHeader.Add New Marketplace'
  });

  return (
    <div>
      <Header />
      <Outlet />
    </div>
  );
};
